export class SeasonalEvents {
    #events = [];

    add(info) {
        if(!this.#events.includes(info))
            this.#events.push(info);
    }

    dispatch(date) {
        date ??= new Date;
        for(const info of this.#events)
            if(info.isActive(date))
                info.dispatch();
    }
};
